export const CURRENT_META = 'CURRENT_META'

export const PAGES_MAP = 'PAGES_MAP'
export const DYNAMIC_TITLE = 'DYNAMIC_TITLE'

export const FETCH_CONF_LIST = 'FETCH_CONF_LIST'

export const FETCH_PAGES = 'FETCH_PAGES'
export const GET_ASSIGNED_PAGE = 'GET_ASSIGNED_PAGE'
export const GET_NAVIGATIONS = 'GET_NAVIGATIONS'

export const FETCH_APP_DETAIL = 'FETCH_APP_DETAIL'
export const SET_APP_DETAIL = 'SET_APP_DETAIL'

export const GET_COMPONENTS = 'GET_COMPONENTS'
export const SET_COMPONENTS = 'SET_COMPONENTS'

export const SET_PAGES_MAP = 'SET_PAGES_MAP'
export const SET_META_PAGES = 'SET_META_PAGES'
export const SET_CONF_META_MAP = 'SET_CONF_META_MAP'
export const SET_CONF_PAGES_MAP = 'SET_CONF_PAGES_MAP'
export const SET_CONF_META = 'SET_CONF_META'
export const SET_CONF_PAGES = 'SET_CONF_PAGES'

export const SET_MODAL = 'SET_MODAL'
export const SET_CLIENT = 'SET_CLIENT'

export const SET_APP_CONTEXT = 'SET_APP_CONTEXT'
export const UPDATE_AUTH_STATUS = 'UPDATE_AUTH_STATUS'

export const CURRENT_ICON_CSS_URL = 'CURRENT_ICON_CSS_URL'

export const GET_APP_SETTING = 'GET_APP_SETTING'
export const SET_APP_SETTING = 'SET_APP_SETTING'

// SET_DYNAMIC_META
export const SET_DYNAMIC_META = 'SET_DYNAMIC_META'
export const GET_DYNAMIC_META = 'GET_DYNAMIC_META'

export const GET_BUILD_FUNCTION_STATUS = 'GET_BUILD_FUNCTION_STATUS'

export const INIT_COMPONENT_INFO_CACHE = 'INIT_COMPONENT_INFO_CACHE'
export const COMPONENT_INFO_CACHE = 'COMPONENT_INFO_CACHE'

export const RESET_CACHE = 'RESET_CACHE'
export const RESET_INFO_CACHE = 'RESET_INFO_CACHE'
export const GET_VALIDATE_FUNCTION_STATUS = 'GET_VALIDATE_FUNCTION_STATUS'

export const GET_LOCAL_COMPONENT = 'GET_LOCAL_COMPONENT'
export const SET_LOCAL_COMPONENT = 'SET_LOCAL_COMPONENT'
export const UPDATE_LOCAL_COMPONENT = 'UPDATE_LOCAL_COMPONENT'
